/* Hover media is only requested on devices that can actually hover. */
(function () {
  const hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
  function loadHoverImages() {
    if (!hoverDevice.matches) return;
    document.querySelectorAll('img.secondary__img[data-src]').forEach((image) => {
      image.srcset = image.dataset.srcset || '';
      image.src = image.dataset.src;
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadHoverImages, { once: true });
  } else {
    loadHoverImages();
  }
  hoverDevice.addEventListener?.('change', loadHoverImages);
  document.addEventListener('shopify:section:load', loadHoverImages);
  new MutationObserver(loadHoverImages).observe(document.documentElement, { childList: true, subtree: true });
})();
